<template>
    <base-modal hide-footer hide-header @close="close">
        <div class="col-12">
            <div class="trip-results" style="height:70vh !important; position: relative">
                <map-container
                    ref="mapContainer"
                    :find-user="false"
                    :menu-items="menuItems"
                    @onPolylineTap="onPolylineTap"
                    @onMapClicked="mapClicked"
                    @onDrag="onDrag"
                    @onDragEnd="onDragEnd"
                    @onMapChanged="mapChanged"
                />
                <div class="map-controls">
                    <div class="map-controls__list col-12 col-lg-4 nopads">
                        <measure-distance-map
                            v-if="measureDistanceEnabled"
                            ref="measureDistances"
                            :map="map"
                            :measure-distance-results="measureDistances"
                            :measure-distance-target-item="measureDistanceTargetItem"
                            :measure-distance-target-item-callback="measureDistanceTargetItemCallback"
                            :draggable="true"
                            @onRemoveMeasureDistances="removeMeasureDistances"
                        />
                        <measure-road-map
                            v-if="measureRoadEnabled"
                            ref="measureRoad"
                            :map="map"
                            :hide-make-new-observation-button="true"
                            :draggable="true"
                            @close="measureRoadEnabled = false"
                            @confirmSelection="createLineObservation"
                        />
                    </div>
                </div>
            </div>
            <div class="map-trip-details-table pl-1 pt-1 pr-1">
                <vue3-datatable
                    :rows="tableItems"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    :height="tableItems.length > 7 ? '40vh' : '100%'"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    @row-click="showSkiTrackOnMap"
                >
                </vue3-datatable>
            </div>
            <div class="nopads">
                <div class="col-md-6 nopads">
                    <div class="button-container">
                        <button class="btn btn-secondary form-button" @click.stop="close">
                            {{ $t('common.close') }}
                        </button>
                    </div>
                </div>
                <div class="col-md-6 nopads">
                    <div class="button-container" style="text-align: left">
                        <button class="btn btn-primary form-button" style="min-width: 7em" @click="showAllTracks">
                            {{ $t('common.show_all') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </base-modal>
</template>

<script>
import MapContainer from "../../map/MapContainer";
import {mapHelper} from '@/components/mixins/MapMixin';
import {restApi} from "@/components/mixins/RestApiMixin";
import {sportHelper} from '@/components/mixins/SportMixin';
import {timeUtils} from '@/components/mixins/TimeUtils'
import {measureDistanceMixin} from "@/components/mixins/MeasureDistanceMixin";
import MeasureDistanceMap from "@/components/map/MeasureDistanceMap";
import MeasureRoadMap from "@/components/map/MeasureRoadMap";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {inject} from "vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: "SportWorkDetails",
    components: {BaseModal, MapContainer, MeasureDistanceMap, MeasureRoadMap, Vue3Datatable},
    mixins: [
        restApi,
        sportHelper,
        mapHelper,
        measureDistanceMixin,
        timeUtils,
    ],
    props: {
        sportWorkItem: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            map: null,
            tableItems: [],
            results: [],
            polyLines: [],
            selectedTrack: null,
            visibleBubble: null,
            loading: false,
            mapItem: null,
            selectMode: 'single',
            measureRoadEnabled: false,
            measureDistances: [],
            measureDistanceEnabled: false,
            measureDistanceTargetItem: null,
            fields: [
                { field: "id", title: this.$t('sports.sport_work_details.id'), sort: true, headerClass: 'routa-table-header' },
                { field: "time", title: this.$t('sports.sport_work_details.time'), sort: true, headerClass: 'routa-table-header' },
                { field: "routeName", title: this.$t('sports.sport_work_details.route_name'), sort: true, headerClass: 'routa-table-header'},
                { field: "county", title: this.$t('sports.sport_work_details.county'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    watch: {
        map() {
            this.fetchSportWorkRecord()
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted() {
        this.setMap()
        this.fetchSportWorkRecord()
    },
    beforeUnmount: function () {
        this.hideTrackInfo()
        this.hideTracks()
    },
    computed: {
        menuItems() {
            return [
                !this.measureDistanceEnabled ? {
                    text: this.$t('map.measure_distance'),
                    onClick: this.initMeasureDistance
                } : {
                    text: this.$t('map.remove_measurements'),
                    onClick: this.removeMeasureDistances
                },
                !this.measureRoadEnabled ? {
                    text: this.$t('map.measure_road'),
                    onClick: this.initMeasureRoad
                } : {
                    text: this.$t('map.remove_measurements'),
                    onClick: this.removeMeasureRoads
                }
            ]
        }
    },
    methods: {
        setMap() {
            this.$nextTick(() => {
                this.map = this.$refs.mapContainer.getMap()
            })
        },

        onDrag: function (data) {
            if (this.measureDistanceEnabled) {
                this.updateMeasureDistance(data)
            }
        },

        onDragEnd: function (data) {
            if (this.measureDistanceEnabled) {
                this.updateMeasureDistance(data)
            }
            if (this.measureRoadEnabled) {
                this.$refs.measureRoad.addMeasurePoint(data)
            }
        },

        mapClicked: function (coord) {
            if (this.measureDistanceEnabled) {
                this.addMeasureDistance(coord)
            }

            if (this.measureRoadEnabled) {
                this.$refs.measureRoad.addMeasurePoint(coord)
            }
        },

        mapChanged(map) {
            this.map = map
        },
        initTableItems: function () {
            this.tableItems = []
            const temp = [9]
            if (this.results && this.results.length > 0) {
                this.results.forEach((item) => {
                    temp.push({
                        id: item.id,
                        time: this.toLocalTime(this.sportWorkItem.time),
                        routeName: item.routeName,
                        county: item.comName
                    })
                })
            }
            this.$nextTick(() => this.tableItems = temp)
        },
        close: function () {
            this.$emit('close')
        },
        fetchSportWorkRecord() {
            this.loading = true
            this.results = []
            this.tableitems = []
            if(this.sportWorkItem) {
                this.restFetch(this.skiingTrackUrl + '/' + this.sportWorkItem.track_id, this.handleResponse, this.handleError)
            }
        },
        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
            this.initTableItems()
            this.showTracks(response.data)
            this.map.zoomToPosition(response.data[0].geometry[0]['y'], response.data[0].geometry[0]['x'])
        },

        showTracks: function (tracks) {
            tracks.forEach(item => {
                if (item.geometry && item.geometry.length > 1) {
                    this.drawSkiingTrack(item.id, item.typeName, item.geometry)
                    this.polyLines.push(item.id)
                }
            })
        },
        showAllTracks() {
            this.showTracks(this.results)
            this.$refs.selectableTable.clearSelected()
        },
        hideTracks: function () {
            this.polyLines.forEach(line => {
                this.map.removePolyline(line, this.SKI_TRACK)
            })
        },
        showSkiTrackOnMap(item) {
            if(item && item[0]) {
                let selectedTrack = this.results.find(result => result.id === item[0].id)
                this.hideTracks()
                this.showTracks([selectedTrack])
                this.map.zoomToPosition(selectedTrack.geometry[0]['y'], selectedTrack.geometry[0]['x'])
            }
        },
        drawSkiingTrack: function (id, type, coords) {
            let color = this.getTypeColor(type)
            this.map.drawPolyLine(id, this.SKI_TRACK, coords, color, false, true, 3)
        },
        onPolylineTap: function (data) {
            this.showTrackInfo(data.id)
        },

        showTrackInfo: function (id) {
            this.hideTrackInfo()
            let track = this.results.find(item => item.id === id)
            if (track) {
                let data = [
                    {name: this.$t('sports.route'), value: track.routeName}
                ]
                this.map.showPolylineBubble(track.id, this.SKI_TRACK, track.geometry[0].y, track.geometry[0].x, this.$t('sports.skiing_track'), data)
                this.visibleBubble = id
                this.selectedTrack = track
            }
        },
        hideTrackInfo: function () {
            if (this.visibleBubble) {
                this.map.hidePolylineBubble(this.visibleBubble, this.SKI_TRACK)
                this.selectedTrack = null
            }
        },
        getTypeColor: function (type) {
            switch (parseInt(type)) {
                case this.SKI_FREESTYLE:
                    return '#52f0ff'
                case this.SKI_CLASSIC:
                    return '#5148ff'
                case this.SKI_LIGHTS:
                    return '#ffbd13'
                case this.SKI_COMPETITION:
                    return '#e454ff'
            }
            return '#2d3b38'
        },
        handleError: function () {
            this.loading = false
            this.showAlert(this.$t('trip_list.err_general'))
        }
    }
}
</script>
